import { useTopOfPageContent } from "@faire/deprecated-retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { Action } from "@faire/slate/foundation/color";
import { getWindow } from "@faire/web/common/globals/getWindow";
import {
  getWindowHeight,
  getWindowWidth,
} from "@faire/web/common/hooks/useObservableWindow";
import { Opacity } from "@faire/web/slate/Color";

export const ResultDropdownBackgroundOverlay = ({
  showBackgroundOverlay,
  onClick,
}: {
  showBackgroundOverlay: boolean;
  onClick: () => void;
}) => {
  const { headerHeight: topOffset } = useTopOfPageContent();
  const pageHeight: number = getWindowHeight() - topOffset;
  // Prefer to use the getWindow()?.document.body.scrollWidth() width of the viewport (if it exists), as this doesn't include the width of the scrollbar
  const pageWidth: number =
    getWindow()?.document.body.scrollWidth ?? getWindowWidth();

  if (!showBackgroundOverlay) {
    return null;
  }

  return (
    <div
      style={{
        position: "absolute",
        top: `${topOffset}px`,
        left: 0,
        width: `${pageWidth}px`,
        height: `${pageHeight}px`,
        backgroundColor: Action.surface.hover + Opacity.O_50,
        zIndex: -1,
      }}
      onClick={onClick}
    />
  );
};
